import React from 'react';

export default function SaveNumberButton({ number, isSaved, onToggle }) {
  if (!number || isNaN(+String(number).trim())) return null;

  return (
    <button
      type="button"
      className={`save-number-btn${isSaved ? ' save-number-btn--saved' : ''}`}
      onClick={() => onToggle(number)}
      aria-pressed={isSaved}
    >
      {isSaved ? '★ บันทึกแล้ว' : '☆ บันทึกเลขนี้'}
    </button>
  );
}
